import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import formField from "MODULES/shared/components/Forms/formField";

function BuyerStoreField({ input, disabled }) {
  const usaClass = classNames("btn btn-default", {
    active: input.value === "USA",
    disabled
  });
  const ireClass = classNames("btn btn-default", {
    active: input.value === "IRE",
    disabled
  });
  const sgpClass = classNames("btn btn-default", {
    active: input.value === "SGP",
    disabled
  });

  const handleBuyerChange = newVal => () => !disabled && input.onChange(newVal);

  return (
    <div className="btn-group btn-group-justified" role="group">
      <div className={usaClass} onClick={handleBuyerChange("USA")}>
        <i className="fa fa-lg fa-check-circle" />
        &nbsp;&nbsp;USA
      </div>
      <div className={ireClass} onClick={handleBuyerChange("IRE")}>
        <i className="fa fa-lg fa-check-circle" />
        &nbsp;&nbsp;IRE
      </div>
      <div className={sgpClass} onClick={handleBuyerChange("SGP")}>
        <i className="fa fa-lg fa-check-circle" />
        &nbsp;&nbsp;SGP
      </div>
    </div>
  );
}

export default formField(BuyerStoreField);

BuyerStoreField.propTypes = {
  input: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/BuyerStoreField.jsx